var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHmrightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.22432 0.239639C0.899202 0.559112 0.899147 1.07718 1.22438 1.39671L8.96198 8.99981L1.22432 16.6033C0.899203 16.9228 0.899148 17.4408 1.22438 17.7604C1.54955 18.0799 2.07672 18.0799 2.40189 17.7604L10.7283 9.57832C10.8844 9.42488 10.9721 9.21679 10.9721 8.99981C10.9721 8.78282 10.8844 8.57468 10.7282 8.4213L2.40184 0.239694C2.07672 -0.0798881 1.54949 -0.0798884 1.22432 0.239639Z",
    fill: "#1361F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHmrightArrow);
export default __webpack_public_path__ + "static/media/hmright_arrow.50a4d799ac36baa16633927b8f4bc816.svg";
export { ForwardRef as ReactComponent };